import semver from 'semver';

export const flipCardDefaultStyles = {
  base: {
    includeFlipcardBackground: true,
    flipcardFrontColor: '#fff',
    flipcardBackColor: '#282A2B',
    flipcardFrontTextColor: '#282A2B',
    flipcardBackTextColor: '#fff',
    flipcardWidth: 300,
    flipcardHeight: 300,
    flipcardBorderRadius: 10,
    alignTextTop: 0,
  },
  '1.5.0': {
    includeFlipcardBackground: true,
    flipcardFrontColor: '#fff',
    flipcardBackColor: '#fff',
    flipcardFrontTextColor: '#282A2B',
    flipcardBackTextColor: '#282A2B',
    flipcardWidth: 300,
    flipcardHeight: 300,
    flipcardBorderRadius: 10,
    alignTextTop: 0,
  },
};

type TFlipCardDefaultStyles = {
  includeFlipcardBackground: boolean;
  flipcardFrontColor: string;
  flipcardBackColor: string;
  flipcardFrontTextColor: string;
  flipcardBackTextColor: string;
  flipcardWidth: number;
  flipcardHeight: number;
  flipcardBorderRadius: number;
  alignTextTop: 0 | 1 | boolean;
};

export const getDefaultStyles = (blockMetaPackageVersion: string = '') => {
  if (!blockMetaPackageVersion || !semver.valid(blockMetaPackageVersion)) {
    return flipCardDefaultStyles['base'];
  }

  if (semver.gte(blockMetaPackageVersion, '1.5.0')) {
    return flipCardDefaultStyles['1.5.0'];
  }
  //

  return flipCardDefaultStyles['base'];
};
